exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".playersBoxDivContainer{margin-bottom:25px}.playersBoxDiv{padding:5px;border:1px solid #8e8e8e;border-radius:3%;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/matches/matchProfile/matchAddShotsTeam/matchAddShotsTeam.scss
// module id = 685
// module chunks = 0